// 文字列へ変換
const stringify = _value => {
  let value = _value;
  if (typeof value !== "string") {
    value = JSON.stringify(value);
  }
  return value;
};
// オブジェクトへ変換
const parse = _value => {
  let value = _value;
  if (typeof value !== "object") {
    try {
      value = JSON.parse(value);
    } catch (e) {
      // 処理なし
    }
  }
  return value;
};

const setItem = (key, value) => localStorage.setItem(key, stringify(value));
const getItem = key => parse(localStorage.getItem(key));
const removeItem = key => localStorage.removeItem(key);

// 定数
const token = "token";
const surveyId = "surveyId";
const devModeFlg = "devModeFlg";
const urlToken = "urlToken";
const previewSurveyId = "previewSurveyId";
const previewRole = "previewRole";
const reloadState = "reloadState";

// 関数
const storage = {
  // 認証トークン
  setToken(value) {
    setItem(token, value);
  },
  setSurveyId(value) {
    setItem(surveyId, value);
  },
  getSurveyId() {
    return getItem(surveyId);
  },
  removeSurveyId(value) {
    removeItem(value);
  },
  getToken() {
    return getItem(token);
  },
  removeToken() {
    removeItem(token);
  },

  // NoMatch画面での表示切替に使用
  setDevModeFlg(flg) {
    setItem(devModeFlg, flg);
  },
  getDevModeFlg() {
    return getItem(devModeFlg);
  },

  // 回答画面のurl token
  setUrlToken(value) {
    setItem(urlToken, value);
  },
  getUrlToken() {
    return getItem(urlToken);
  },
  removeUrlToken() {
    removeItem(urlToken);
  },

  // プレビュー用のアンケートID
  setPreviewSurveyId(id) {
    setItem(previewSurveyId, id);
  },
  getPreviewSurveyId() {
    return getItem(previewSurveyId);
  },

  // プレビュー時のロール
  setPreviewRole(role) {
    setItem(previewRole, role);
  },
  getPreviewRole() {
    return getItem(previewRole);
  },

  // reload情報
  setReloaded() {
    setItem(reloadState, true);
  },
  isReloaded() {
    return getItem(reloadState);
  },
  removeReloaded() {
    removeItem(reloadState);
  }
};

export default storage;



// WEBPACK FOOTER //
// ./src/utils/storage.js